import { advantages } from '@/mocks/promotions';

export default function AdvantagesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择新葡京娱乐城
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大核心优势，为您提供顶级在线娱乐体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {advantages.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center p-8 rounded-lg bg-background-50 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-5">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}